import React from 'react';

const FocusGroupSessionSkeleton: React.FC = () => (
  <div
    role="status"
    aria-label="Loading focus group session"
    className="min-h-screen bg-gray-50 relative overflow-hidden"
  >
    <div className="absolute inset-0 w-full h-full animate-shimmer bg-gradient-to-r from-transparent via-white/60 to-transparent z-10 pointer-events-none" />
    <div className="max-w-4xl mx-auto px-4 py-12">
      <div className="h-10 bg-gray-200/70 rounded-lg w-44 mb-6 animate-pulse" />
      <div className="bg-white rounded-xl shadow-lg p-8 border border-gray-100 space-y-6">
        <div className="flex flex-col items-center gap-4">
          <div className="w-16 h-16 bg-gray-200/70 rounded-full animate-pulse" />
          <div className="h-7 bg-gray-200/70 rounded w-64 animate-pulse" />
          <div className="h-4 bg-gray-200/70 rounded w-full max-w-md animate-pulse" />
        </div>
        <div className="space-y-4">
          {Array.from({ length: 3 }).map((_, index) => (
            <div key={index} className="border border-[#E9E9E9] rounded-xl p-4 space-y-3">
              <div className="h-5 bg-gray-200/70 rounded w-2/3 animate-pulse" />
              <div className="h-10 bg-gray-200/70 rounded w-full animate-pulse" />
            </div>
          ))}
        </div>
        <div className="h-12 bg-gray-200/70 rounded-lg w-full animate-pulse" />
      </div>
    </div>
    <span className="sr-only">Loading focus group session...</span>
  </div>
);

export default FocusGroupSessionSkeleton;
